import React from "react";
import { useIntl } from "react-intl";

import { ListRunsStatusEnum, PlatformSyncStatusDTO } from "@app/api/generated";
import { SelectComponent } from "@app/core/select";

import { getPlatformName, orderPlatformsByKeys } from "@app/util/platform-name";
import styles from "@app/styles/dashboard/filter-bar.module.scss";
import { RUN_STATUS_LABEL_KEY } from "@app/util/run-status";

interface ISyncFilterBarProps {
  platforms: PlatformSyncStatusDTO[];
  statusFilter?: ListRunsStatusEnum;
  platformFilter?: number;
  onStatusChange: (status?: ListRunsStatusEnum) => void;
  onPlatformChange: (platformId?: number) => void;
}

const SyncFilterBar = ({
  platforms,
  statusFilter,
  platformFilter,
  onStatusChange,
  onPlatformChange
}: ISyncFilterBarProps): JSX.Element => {
  const intl = useIntl();

  const statusOptions = [
    { id: "", name: intl.formatMessage({ id: "productPageSync.filter.allStatuses" }) },
    ...Object.values(ListRunsStatusEnum).map((status) => ({
      id: status,
      name: intl.formatMessage({ id: RUN_STATUS_LABEL_KEY[status] })
    }))
  ];

  const platformOptions = [
    { id: 0, name: intl.formatMessage({ id: "productPageSync.filter.allPlatforms" }) },
    ...orderPlatformsByKeys(platforms, (platform) => platform.productPageSyncEnabled).map((platform) => ({
      id: platform.platformId,
      name: getPlatformName(intl, platform.platformId, platform.name)
    }))
  ];

  return (
    <div className={styles.filterBar}>
      <SelectComponent
        autoWidth
        value={statusFilter ?? ""}
        options={statusOptions}
        onChange={(e) => {
          const { value } = e.target;
          onStatusChange(value ? (value as ListRunsStatusEnum) : undefined);
        }}
      />
      <SelectComponent
        autoWidth
        value={platformFilter ?? 0}
        options={platformOptions}
        onChange={(e) => onPlatformChange(Number(e.target.value) || undefined)}
      />
    </div>
  );
};

export { SyncFilterBar };
